import { TFunction } from 'i18next'
import * as yup from 'yup'

export const DEFAULT_REMEDIAL =
    '<ul><li><p>Cách khắc phục/ Giải pháp:  </p></li></ul>'
export const DEFAULT_AVOID = '<ul><li><p>Phòng ngừa:  </p></li></ul>'
export const DEFAULT_ROOT_CAUSE =
    '<p>(Lý do xảy ra sự cố này là gì?)</p><p>Nguyên nhân gốc: </p>'
export const DEFAULT_INTERNAL_REMEDIAL = DEFAULT_REMEDIAL
export const DEFAULT_INTERNAL_AVOID = DEFAULT_AVOID
export const DEFAULT_INTERNAL_ROOT_CAUSE = DEFAULT_ROOT_CAUSE

export const resolvedIncidentSchema = (
    t: TFunction<'translation', undefined>
) =>
    yup.object().shape({
        ticket_remedial_measures: yup.object().shape({
            text: yup
                .string()
                .required(t('blank-errors'))
                .test(
                    'not-equal-default-remedial',
                    t('blank-errors'),
                    (value) => normalize(value) !== normalize(DEFAULT_REMEDIAL)
                ),
            attachments: yup.array().of(yup.mixed()).notRequired(),
        }),

        ticket_avoid: yup.object().shape({
            text: yup
                .string()
                .required(t('blank-errors'))
                .test(
                    'not-equal-default-avoid',
                    t('blank-errors'),
                    (value) => normalize(value) !== normalize(DEFAULT_AVOID)
                ),
            attachments: yup.array().of(yup.mixed()).notRequired(),
        }),

        ticket_root_cause: yup.object().shape({
            text: yup
                .string()
                .required(t('blank-errors'))
                .test(
                    'not-equal-default-root-cause',
                    t('blank-errors'),
                    (value) =>
                        normalize(value) !== normalize(DEFAULT_ROOT_CAUSE)
                ),
            attachments: yup.array().of(yup.mixed()).notRequired(),
        }),

        ticket_internal_remedial_measures: yup.object().shape({
            text: yup
                .string()
                .required(t('blank-errors'))
                .test(
                    'not-equal-default-internal-remedial',
                    t('blank-errors'),
                    (value) =>
                        normalize(value) !==
                        normalize(DEFAULT_INTERNAL_REMEDIAL)
                ),
            attachments: yup.array().of(yup.mixed()).notRequired(),
        }),

        ticket_internal_avoid: yup.object().shape({
            text: yup
                .string()
                .required(t('blank-errors'))
                .test(
                    'not-equal-default-internal-avoid',
                    t('blank-errors'),
                    (value) =>
                        normalize(value) !== normalize(DEFAULT_INTERNAL_AVOID)
                ),
            attachments: yup.array().of(yup.mixed()).notRequired(),
        }),

        ticket_internal_root_cause: yup.object().shape({
            text: yup
                .string()
                .required(t('blank-errors'))
                .test(
                    'not-equal-default-internal-root-cause',
                    t('blank-errors'),
                    (value) =>
                        normalize(value) !==
                        normalize(DEFAULT_INTERNAL_ROOT_CAUSE)
                ),
            attachments: yup.array().of(yup.mixed()).notRequired(),
        }),

        ticket_time_release: yup.mixed().notRequired(),
    })

const normalize = (str?: string) => str?.replace(/\s+/g, '').toLowerCase() ?? ''
